module.exports = __webpack_public_path__ + "img/menu-button.4500ca6e.svg";